
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '../../../controlador';
    import { Pregunta } from '@/__env/lib/MercadoLibre/Preguntas';
    import { Publicacion } from '@/__env/lib/MercadoLibre/Publicaciones';
    import { Wait, WaitEntre } from '@/__env/ext';
    @Component( {
        name: "Componente",
        props: {},
        components: {}
    } )
    export default class Componente extends Vue
    {

        @Prop() public Controlador: ControladorInterfaz;
        @Prop() public Pregunta: Pregunta;
        @Prop() public Seleccionada: boolean;

        public get Pedido() { return this.Controlador.Pedido; }
        public get SubModo() { return this.Controlador.Vista.BarraDerecha.SubModo; }
        public set SubModo( x: string ) { this.Controlador.Vista.BarraDerecha.SubModo = x; }
        public get Modo() { return this.Controlador.Vista.BarraDerecha.Modo; }
        public set Modo( x: string ) { this.Controlador.Vista.BarraDerecha.Modo = x; }
        public get ReservarEspacioDerecha() { return this.Controlador.Vista.BarraDerecha.Anchura.Espacio; }
        public get MismaPublicacion()
        {
            let pp: Publicacion[] = [];
            for ( let it of this.Pedido.Items )
            {
                if ( it.Publicacion && it.Publicacion instanceof Publicacion )
                    pp.push( it.Publicacion );
            }
            return this.Pregunta.TestMismaPublicacion( pp );
        }

        public Cargando: boolean = true;
        async mounted()
        {
            if ( this.MismaPublicacion )
            {
                this.Cargando = true;
                await WaitEntre( 1000, 3000 );
                await this.Pregunta.CargarPublicacion();
                this.Cargando = false;
            } else
            {
                this.Cargando = false;
            }
        }

        Abrir()
        {
            if ( this.Pregunta.Publicacion && this.Pregunta.Publicacion.Link )
                window.open( this.Pregunta.Publicacion.Link );
        }

    }
